import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-subtitle-2 text-grey" }
const _hoisted_2 = {
  key: 0,
  class: "text-center pa-4"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center pa-4"
}
const _hoisted_4 = { class: "text-body-2" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "d-flex align-center mb-2" }
const _hoisted_8 = { class: "text-body-2" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "d-flex align-center mb-2" }
const _hoisted_11 = { class: "text-h6" }
const _hoisted_12 = { class: "text-caption text-grey" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "d-flex flex-wrap ga-2" }
const _hoisted_15 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_16 = { class: "text-body-2" }
const _hoisted_17 = {
  key: 0,
  class: "mt-4"
}

import { ref, computed, watch } from 'vue'
import InventoryTable from '@/components/inventory/InventoryTable.vue'
import { useEquipmentMatching, type Equipment, type Request } from '@/composables/useEquipmentMatching'

interface School {
  id: string
  _id?: string
  name: string
}

interface Props {
  show: boolean
  request: Request | null
  equipment: Equipment[]
  loading?: boolean
  schools: School[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EquipmentSelectionModal',
  props: {
    show: { type: Boolean },
    request: {},
    equipment: { default: () => [] },
    loading: { type: Boolean, default: false },
    schools: { default: () => [] }
  },
  emits: ['update:show', 'claim', 'unclaim'],
  setup(__props: any) {

/* eslint-disable no-undef */
const props = __props



const { findBestMatch, sortEquipmentByMatch, formatTaskName } = useEquipmentMatching()

const showOtherOptions = ref(false)

const sortedMatches = computed(() => {
  if (!props.request || !props.equipment || props.equipment.length === 0) return []
  const matches = sortEquipmentByMatch(props.equipment, props.request)
  console.log('Sorted matches:', matches)
  return matches
})

const bestMatch = computed(() => {
  if (sortedMatches.value.length === 0) return null
  const best = sortedMatches.value[0]
  console.log('Best match:', best)
  return best
})

const otherOptions = computed(() => {
  if (sortedMatches.value.length <= 1) {
    console.log('No other options, sorted matches length:', sortedMatches.value.length)
    return []
  }
  const others = sortedMatches.value.slice(1)
  console.log('Other options:', others.length)
  return others
})

const getSchoolName = (schoolId: string | undefined) => {
  if (!schoolId) return 'N/A'
  const school = props.schools.find((s: School) => s.id === schoolId || s._id === schoolId)
  return school ? school.name : schoolId
}

const getRatingColor = (rating: number | null) => {
  if (!rating) return 'grey'
  if (rating >= 8) return 'success'
  if (rating >= 6) return 'light-green'
  if (rating >= 4) return 'lime'
  return 'yellow-darken-2'
}

const getMatchScoreColor = (score: number) => {
  if (score === 100) return 'success'
  if (score >= 75) return 'light-green'
  if (score >= 50) return 'warning'
  return 'error'
}

// Reset showOtherOptions when modal closes or request changes
watch(() => props.show, (newVal) => {
  if (!newVal) {
    showOtherOptions.value = false
  }
})

watch(() => props.request?.id, () => {
  showOtherOptions.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.show,
    "max-width": "1200px",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:show', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Select Equipment", -1)),
                _createElementVNode("p", _hoisted_1, " For " + _toDisplayString(__props.request?.student_name) + " - " + _toDisplayString(getSchoolName(__props.request?.school)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (__props.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary"
                    })
                  ]))
                : (!bestMatch.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_alert, {
                        type: "warning",
                        variant: "tonal"
                      }, {
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-body-1 mb-2" }, [
                            _createElementVNode("strong", null, "No equipment meets the requirements for this request.")
                          ], -1)),
                          _createElementVNode("div", _hoisted_4, " This request requires equipment with a minimum rating of " + _toDisplayString(__props.request?.minimum_rating || 1) + ", but there is no available equipment that meets this requirement. ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-h6" }, "Best Match", -1)),
                          _createVNode(_component_v_chip, {
                            class: "ml-2",
                            color: getMatchScoreColor(bestMatch.value.matchScore),
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(bestMatch.value.matchScore) + "% Match ", 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        (bestMatch.value.matchScore < 100)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: "warning",
                              variant: "tonal",
                              class: "mb-3"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _cache[11] || (_cache[11] = _createTextVNode(" Tasks highlighted in ", -1)),
                                  _createVNode(_component_v_chip, {
                                    size: "x-small",
                                    color: "error",
                                    class: "mx-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                      _createTextVNode("red", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[12] || (_cache[12] = _createTextVNode(" are requested by the student but not supported by this equipment. Tasks in ", -1)),
                                  _createVNode(_component_v_chip, {
                                    size: "x-small",
                                    color: "success",
                                    class: "mx-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("green", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[13] || (_cache[13] = _createTextVNode(" are both requested and supported. Note: Equipment may still be capable of performing red-highlighted tasks, but it may not be ideal for them. ", -1))
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_card, {
                          variant: "outlined",
                          class: "best-match-card"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_9, [
                                          _createElementVNode("div", _hoisted_10, [
                                            _createVNode(_component_v_chip, {
                                              color: "secondary",
                                              size: "small",
                                              class: "mr-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(bestMatch.value.equipment.equipment_type), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_chip, {
                                              color: getRatingColor(bestMatch.value.equipment.rating),
                                              size: "small",
                                              variant: "flat"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Rating: " + _toDisplayString(bestMatch.value.equipment.rating || '-'), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["color"])
                                          ]),
                                          _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("strong", null, _toDisplayString(bestMatch.value.equipment.manufacturer), 1),
                                            _createTextVNode(" " + _toDisplayString(bestMatch.value.equipment.model), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_12, " Asset Tag: " + _toDisplayString(bestMatch.value.equipment.asset_tag || 'N/A'), 1)
                                        ]),
                                        _createVNode(_component_v_row, { dense: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                              default: _withCtx(() => [
                                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-caption text-grey" }, "CPU", -1)),
                                                _createElementVNode("div", null, _toDisplayString(bestMatch.value.equipment.cpu || 'N/A'), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                              default: _withCtx(() => [
                                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-caption text-grey" }, "RAM", -1)),
                                                _createElementVNode("div", null, _toDisplayString(bestMatch.value.equipment.ram || 'N/A'), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                              default: _withCtx(() => [
                                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-caption text-grey" }, "Storage", -1)),
                                                _createElementVNode("div", null, _toDisplayString(bestMatch.value.equipment.storage || 'N/A'), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                              default: _withCtx(() => [
                                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-caption text-grey" }, "GPU", -1)),
                                                _createElementVNode("div", null, _toDisplayString(bestMatch.value.equipment.gpu || 'N/A'), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        (__props.request?.needed_for && __props.request.needed_for.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-caption text-grey mb-2" }, "Task Compatibility", -1)),
                                              _createElementVNode("div", _hoisted_14, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.needed_for, (task) => {
                                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                                    key: task,
                                                    size: "small",
                                                    color: bestMatch.value.supportedTasks.includes(task) ? 'success' : 'error',
                                                    variant: bestMatch.value.supportedTasks.includes(task) ? 'flat' : 'tonal'
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (bestMatch.value.supportedTasks.includes(task))
                                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                                            key: 0,
                                                            start: "",
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                              _createTextVNode("mdi-check", -1)
                                                            ]))]),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                                            key: 1,
                                                            start: "",
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                              _createTextVNode("mdi-close", -1)
                                                            ]))]),
                                                            _: 1
                                                          })),
                                                      _createTextVNode(" " + _toDisplayString(_unref(formatTaskName)(task)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["color", "variant"]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (bestMatch.value.equipment.comments)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-caption text-grey" }, "Comments", -1)),
                                              _createElementVNode("div", _hoisted_16, _toDisplayString(bestMatch.value.equipment.comments), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  color: "success",
                                  variant: "elevated",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('claim', bestMatch.value.equipment)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { start: "" }, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createTextVNode("mdi-hand-extended", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[23] || (_cache[23] = _createTextVNode(" Claim This Equipment ", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      (otherOptions.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_v_divider, { class: "mb-4" }),
                            _createVNode(_component_v_btn, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (showOtherOptions.value = !showOtherOptions.value)),
                              variant: "outlined",
                              color: "primary",
                              block: "",
                              class: "mb-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(showOtherOptions.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(showOtherOptions.value ? 'Hide' : 'See') + " Other Options (" + _toDisplayString(otherOptions.value.length) + ") ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_expand_transition, null, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("div", null, [
                                  _createVNode(InventoryTable, {
                                    equipment: otherOptions.value.map(m => m.equipment),
                                    loading: false,
                                    "request-mode": true,
                                    "request-data": __props.request,
                                    "items-per-page": 10,
                                    onClaim: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('claim', $event))),
                                    onUnclaim: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('unclaim', $event)))
                                  }, null, 8, ["equipment", "request-data"])
                                ], 512), [
                                  [_vShow, showOtherOptions.value]
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "grey",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:show', false)))
              }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})